<template>
  <div class="supplier-bid">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item class="bigData-btn-bidQuery" index="bidQuery">应标查询</el-menu-item>
      <el-menu-item class="bigData-btn-costQuery" index="costQuery">费用查询</el-menu-item>
      <el-menu-item class="bigData-btn-cocurrentAndConvection" index="cocurrentAndConvection">对流供应商推荐</el-menu-item>
      <el-menu-item class="bigData-btn-reserveSuppliers" index="reserveSuppliers">储备供应商推荐</el-menu-item>
      <el-menu-item class="bigData-btn-urbanDeliverySuppliers" index="urbanDeliverySuppliers">城配供应商智能推荐
        <el-tooltip class="item" effect="dark" placement="right">
          <div slot="content" v-html="helpTips"></div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </el-menu-item>
    </el-menu>
    <component :is="defaultComponent"></component>
  </div>
</template>
<script>
import bidQuery from './bidQuery.vue';
import costQuery from './costQuery.vue';
import cocurrentAndConvection from './cocurrentAndConvection.vue';
import reserveSuppliers from './reserveSuppliers.vue';
import urbanDeliverySuppliers from './urbanDeliverySuppliers.vue';
const TIPS='<div>根据现有系统供方星级情况，按始发省份匹配区域划分进行智能推送A级供应商</div>'
+'<div>①东北地区：黑龙江、吉林、辽宁</div>'
+'<div>②华北地区：山东、河北、北京、天津、山西、内蒙古</div>'
+'<div>③华东地区：江苏、安徽、上海、浙江、福建</div>'
+'<div>④华中地区：河南、湖北、湖南、江西</div>'
+'<div>⑤华南地区：广东、广西、海南、香港、澳门、台湾</div>'
+'<div>⑥西南地区：四川、云南、贵州、重庆</div>'
+'<div>⑦西北地区：陕西、甘肃、宁夏、青海、西藏、新疆</div>';

export default {
    components: { bidQuery, costQuery, cocurrentAndConvection,reserveSuppliers,urbanDeliverySuppliers },
    data() {
        return {
            activeIndex: 'bidQuery',
            defaultComponent: 'bidQuery',
            helpTips:TIPS,
        };
    },
    methods: {
        handleSelect(key) {
            this.defaultComponent = key;
        }
    },
    created() {
      if (this.$route.query.active === 'costQuery') {
        this.activeIndex = 'costQuery'
        this.defaultComponent = 'costQuery'
      }
    },
};
</script>
<style lang="less" >
.supplier-bid{
    .is-active{font-weight: 700}
    .el-menu-item{font-size: 14px;}
    .el-menu-demo{margin-bottom: 15px;}
}
</style>